function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m5.47330012 4.98191314c-6.6518035 6.65410766-6.6518035 17.43623226 0 24.09033996.14946319.1472771.29892639.2903464.4504947.4207919l-5.92379482 5.9205429c6.7081648 6.266896 17.1796078 6.0901885 23.6722668-.3994738 6.492659-6.4896624 6.6685478-16.9553724.397623-23.6593067l5.9301102-5.92475081c-.1410427-.15148511-.2841906-.30297022-.4336538-.45024741-6.6571336-6.64056683-17.4370736-6.63962546-24.09304608.00210396zm17.73349238 7.24814156c5.3068555 5.7363968 5.6148106 14.4904042.7241597 20.5851429-6.1391973 2.4887827-13.1650437 1.1982594-18.01768296-3.3095288l17.28720796-17.2756141zm0-1.7610144c-4.8457466-4.50361257-11.8609583-5.79861064-17.99663181-3.3221525 2.74268214-3.40611715 6.77640111-5.52225055 11.13911171-5.84370069s8.6633149 1.18059957 11.8761153 4.14790907z",
  fill: "#fff"
});

var SvgSignWhite = function SvgSignWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 30 40",
    width: 30,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-white.dde33405.svg";
export { ForwardRef as ReactComponent };